import { useEffect, useState } from "react";
import { PRESS_LOGOS } from "../../lib/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Press strip — reads partner logos from the backend (editable in /admin),
// falling back to the bundled starter content if the API is unreachable.
export default function PressStrip() {
  const [logos, setLogos] = useState(PRESS_LOGOS);

  useEffect(() => {
    fetch(`${API}/site-content`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (d?.logos?.length) setLogos(d.logos);
      })
      .catch(() => {});
  }, []);

  return (
    <section
      data-testid="press-strip-section"
      className="bg-white border-b-2 border-[#1A1A1A]"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10 lg:px-12 py-8 md:py-10">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#4A4A4A] text-center">
          A decade of Real Delivery - Inspired by
        </p>
        <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-8 md:gap-x-12 gap-y-4">
          {logos.map((l, i) => (
            <li key={l.id || i} data-testid={`press-logo-${i}`} className="flex items-center">
              {l.image_path ? (
                <img
                  src={`${API}/files/${l.image_path}`}
                  alt={l.label}
                  title={l.label}
                  className="h-7 md:h-9 w-auto max-w-[140px] object-contain opacity-60 hover:opacity-100 transition-opacity duration-300"
                />
              ) : (
                <span
                  className={`font-display font-black text-lg md:text-2xl tracking-tight text-[#1A1A1A]/70 hover:text-[#1A1A1A] transition-colors ${
                    l.italic ? "italic" : ""
                  }`}
                >
                  {l.label}
                  {!l.real && (
                    <span
                      aria-hidden
                      className="inline-block ml-1 h-1.5 w-1.5 rounded-full bg-[#FFD700] align-super"
                    />
                  )}
                </span>
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
